import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const StoreIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4458 0.585787C12.2268 -0.195262 13.4931 -0.195263 14.2742 0.585786L16.4163 2.72792C17.1974 3.50897 17.1974 4.7753 16.4163 5.55635L14.2742 7.69848C13.4931 8.47953 12.2268 8.47953 11.4458 7.69848L9.30362 5.55635C8.52258 4.7753 8.52257 3.50897 9.30362 2.72792L11.4458 0.585787ZM2 1.0245C0.895431 1.0245 0 1.91993 0 3.0245V7.01411C0 8.11868 0.89543 9.01411 2 9.01411H5.98961C7.09418 9.01411 7.98961 8.11868 7.98961 7.01411V3.0245C7.98961 1.91993 7.09418 1.0245 5.98961 1.0245H2ZM9.98961 9.01411C8.88504 9.01411 7.98961 9.90954 7.98961 11.0141V15.0037C7.98961 16.1083 8.88504 17.0037 9.9896 17.0037H13.9792C15.0838 17.0037 15.9792 16.1083 15.9792 15.0037V11.0141C15.9792 9.90954 15.0838 9.01411 13.9792 9.01411H9.98961ZM0 12.0128C0 10.9082 0.895431 10.0128 2 10.0128H4.99091C6.09547 10.0128 6.99091 10.9082 6.99091 12.0128V15.0037C6.99091 16.1083 6.09547 17.0037 4.99091 17.0037H2C0.89543 17.0037 0 16.1083 0 15.0037V12.0128Z"
      />
    </svg>
  </span>
);

export default StoreIcon;
